module.exports = __webpack_public_path__ + "static/media/Slice2@2x.7db658a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/Slice2@2x.png
// module id = 1407
// module chunks = 0